/*!
 * basic sophiacloud javascript for websites 
 */

//'use strict';

module.exports = require('./src/scl-formulaire.js');
